import { useState, useEffect } from 'react';
import Select from 'react-select';
import DropDownStyles from './dropdownStyles';

const parseNumericAge = (v) => {
  if (v === '' || v == null) return null;
  const n = typeof v === 'number' ? v : parseFloat(String(v).trim());
  return Number.isFinite(n) ? n : null;
};

const AgeOfPondSelector = ({ value, onChange, error }) => {
  const [ageType, setAgeType] = useState(value?.ageType || null);
  const [ageInYears, setAgeInYears] = useState(value?.ageInYears ?? '');

  useEffect(() => {
    if (!value) return;
    const n = parseNumericAge(value.ageInYears);
    if (n !== null) {
      setAgeType('Age (years)');
      setAgeInYears(
        value.ageInYears === null || value.ageInYears === undefined
          ? ''
          : String(value.ageInYears)
      );
    } else {
      setAgeType(value.ageType || null);
      setAgeInYears(
        value.ageInYears !== null && value.ageInYears !== undefined
          ? String(value.ageInYears)
          : ''
      );
    }
  }, [value]);

  const ageTypeOptions = [
    { value: 'Unknown', label: 'Unknown' },
    { value: 'Age (years)', label: 'Age (years)' }
  ];

  const handleAgeTypeChange = (selectedOption) => {
    const newAgeType = selectedOption ? selectedOption.value : null;
    setAgeType(newAgeType);

    if (newAgeType === 'Unknown') {
      setAgeInYears('');
      onChange({ ageType: 'Unknown', ageInYears: null });
    } else if (!newAgeType) {
      setAgeInYears('');
      onChange({ ageType: null, ageInYears: null });
    } else {
      onChange({ ageType: newAgeType, ageInYears: ageInYears ? parseFloat(ageInYears) : null });
    }
  };

  const handleAgeInYearsChange = (e) => {
    const newAge = e.target.value;
    setAgeInYears(newAge);
    const n = parseNumericAge(newAge);
    if (n !== null) {
      setAgeType('Age (years)');
      onChange({ ageType: 'Age (years)', ageInYears: n });
    } else {
      setAgeType(null);
      onChange({ ageType: null, ageInYears: null });
    }
  };

  const numericAgeEntered = parseNumericAge(ageInYears) !== null;
  const showAgeTypeSelect = !numericAgeEntered;
  const showYearsInput = ageType === 'Age (years)' || numericAgeEntered;

  return (
    <div>
      <label className="form-label mb-2" style={{ color: '#2d353c', fontSize: '0.95rem', fontWeight: '600' }}>
        Age of Pond
      </label>
      {showAgeTypeSelect && (
        <div className="mb-3">
          <Select
            value={ageTypeOptions.find(opt => opt.value === ageType)}
            onChange={handleAgeTypeChange}
            options={ageTypeOptions}
            styles={{
              ...DropDownStyles,
              control: (base, state) => ({
                ...base,
                minHeight: '50px',
                border: state.isFocused ? '2px solid #ff9800' : '1px solid #e0e0e0',
                borderRadius: '10px',
                fontSize: '0.95rem',
                backgroundColor: state.isFocused ? '#fff' : '#fafafa',
                boxShadow: state.isFocused ? '0 0 0 3px rgba(255, 152, 0, 0.1)' : 'none',
                transition: 'all 0.3s ease',
                '&:hover': {
                  border: '1px solid #ff9800'
                }
              })
            }}
            placeholder="Select Age Type"
            isClearable={true}
          />
        </div>
      )}

      {showYearsInput && (
        <div className="form-floating mb-0">
          <input
            type="number"
            className="form-control"
            placeholder="Age in Years"
            value={ageInYears}
            onChange={handleAgeInYearsChange}
            min="0"
            step="0.1"
            style={{ 
              border: '1px solid #e0e0e0',
              borderRadius: '10px',
              height: '50px',
              fontSize: '0.95rem',
              transition: 'all 0.3s ease',
              backgroundColor: '#fafafa'
            }}
            onFocus={(e) => {
              e.target.style.borderColor = '#ff9800';
              e.target.style.backgroundColor = '#fff';
              e.target.style.boxShadow = '0 0 0 3px rgba(255, 152, 0, 0.1)';
            }}
            onBlur={(e) => {
              e.target.style.borderColor = '#e0e0e0';
              e.target.style.backgroundColor = '#fafafa';
              e.target.style.boxShadow = 'none';
            }}
          />
          <label style={{ color: '#6c757d', fontSize: '0.9rem', fontWeight: '500' }}>
            Age (years)
          </label>
        </div>
      )}
      {error && <div className="text-danger mt-2" style={{ fontSize: '0.85rem' }}>{error}</div>}
    </div>
  );
};

export default AgeOfPondSelector;

